<template>
  <div>
    <q-dialog 
      :visible="isVisible"
      :title="isEdit ? '编辑' : '新增'"
      width="800px"
      :innerScroll="false"
      :offsetHeight="170"
      :loading="confirmLoading"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm" size="mini" label-width="130px" class="form-content">
        <el-form-item label="生效周期" required>
          <form-date-range
            :form="formData"
            :usingTime="false"
            startKey="startDate"
            endKey="endDate"
            valueFormat="yyyyMMdd"
          />
        </el-form-item>

        <div class="section-title">报名统计数据范围</div>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单状态" prop="orderStatus">
              <el-select class="input-box" v-model="formData.orderStatus" placeholder="请选择" multiple collapse-tags @change="handleOrderStatusChange">
                <el-option v-show="!allStatus" label="全部" value="all" />
                <el-option v-show="allStatus" label="取消所有" value="cancelAll" />
                <el-option label="待核销" value="1" />
                <el-option label="已核销" value="2" />
                <el-option label="已退款" value="3" />
                <el-option label="退款中" value="6" />
                <el-option label="待退款" value="7" />
                <el-option label="已线下退款" value="9" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额" prop="orderAmountOpt">
              <div class="amount-wrapper">
                <el-select class="amount-select" v-model="formData.orderAmountOpt" placeholder="请选择">
                  <el-option label="小于" value="lt" />
                  <el-option label="小于等于" value="le" />
                  <el-option label="等于" value="eq" />
                  <el-option label="大于" value="gt" />
                  <el-option label="大于等于" value="ge" />
                </el-select>
                <el-input 
                  class="amount-input" 
                  v-model="formData.orderAmount" 
                  placeholder="请输入"
                  maxlength="10"
                  @input="handleAmountInput"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="section-title">销售单量目标配置</div>
        
        <el-row :gutter="20">
          <el-col :span="12" v-for="(area, index) in formData.organizations" :key="area.organizationId">
            <el-form-item 
              label-width="130px"
              :label="area.organizationName" 
              :prop="'organizations.' + index + '.saleTargetAmount'"
              :rules="[{ required: true, message: '请输入' + area.organizationName + '目标', trigger: 'blur' }]"
            >
              <el-input 
                class="input-box" 
                v-model="area.saleTargetAmount" 
                maxlength="10" 
                @input="val => handleTargetInput(index, val)"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form> 
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default() {
        return {}
      } 
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(newVal) {
        this.$emit('update:visible', newVal)
      }
    }
  },
  data() {
    return {
      areaList: [],
      allStatus: true,
      confirmLoading: false,
      formData: this.getInitFormData(),
      rules: {
        startDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' },
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ],
        orderStatus: [
          { required: true, message: '请选择订单状态', trigger: 'change' },
        ],
        orderAmountOpt: [
          { required: true, message: '请选择订单金额条件', trigger: 'change' },
        ],
      }
    }
  },
  created() {
    if (this.isEdit) {
      this.initFormData()
    } else {
      // 新增时获取区域列表并初始化 organizations
      this.getAreaList()
    }
  },
  methods: {
    getInitFormData() {
      return {
        id: '',
        startDate: '',
        endDate: '',
        orderStatus: ['1', '2', '3', '6', '7', '9'],
        orderAmountOpt: 'lt',
        orderAmount: '',
        organizations: []
      }
    },
    initFormData() {
      // 编辑时将 editData 深拷贝到 formData
      this.formData = {
        ...this.getInitFormData(),
        ...this.editData,
        orderStatus: this.editData.orderStatusList || [],
        orderAmount: this.editData.orderAmountConfig || '',
        organizations: this.editData.organizations ? 
          this.editData.organizations.map(item => ({ ...item })) : []
      }
      // 设置全选状态
      const allStatusValues = ['1', '2', '3', '6', '7', '9']
      this.allStatus = allStatusValues.length === (this.formData.orderStatus && this.formData.orderStatus.length)
    },
    onCancel() {
      this.isVisible = false
      this.$refs.ruleForm.resetFields()
      this.formData = this.getInitFormData()
    },
    // 处理订单状态全选
    handleOrderStatusChange(val) {
      const allStatusValues = ['1', '2', '3', '6', '7', '9']
      this.allStatus = allStatusValues.length === val.length
      
      if (val.includes('all')) {
        // 选择了"全部"，勾选所有状态
        this.formData.orderStatus = [...allStatusValues]
        this.allStatus = true
      } else if (val.includes('cancelAll')) {
        // 选择了"取消所有"，清空所有
        this.formData.orderStatus = []
        this.allStatus = false
      }
    },
    // 处理订单金额输入，支持2位小数
    handleAmountInput(val) {
      // 只允许数字和小数点，最多2位小数
      let value = val.replace(/[^\d.]/g, '')
      // 只保留第一个小数点
      const parts = value.split('.')
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('')
      }
      // 小数点后最多2位
      if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + '.' + parts[1].slice(0, 2)
      }
      this.formData.orderAmount = value
    },
    // 处理销售目标输入，只允许整数
    handleTargetInput(index, val) {
      // 只允许数字，不支持小数
      const value = val.replace(/[^\d]/g, '')
      this.$set(this.formData.organizations[index], 'saleTargetAmount', value)
    },
    // 获取区域列表
    getAreaList() {
      this.$api.configure.queryAreaList().then(res => {
        if (res.success && res.data) {
          this.areaList = res.data
          // 新增时初始化 organizations
          this.formData.organizations = res.data.map(area => ({
            organizationId: area.organizationId,
            organizationName: area.organizationName,
            saleTargetAmount: ''
          }))
        }
      })
    },
    onConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 构建 saleTargetDtls 数组
          const saleTargetDtls = this.formData.organizations.map(area => ({
            organizationId: area.organizationId,
            organizationName: area.organizationName,
            saleTargetAmount: Number(area.saleTargetAmount || 0),
          }))
          
          // 构建保存接口的传参格式
          const params = {
            id: this.formData.id || '',
            startDate: this.formData.startDate,
            endDate: this.formData.endDate,
            orderStatus: this.formData.orderStatus,
            orderAmountOpt: this.formData.orderAmountOpt,
            orderAmountConfig: Number(this.formData.orderAmount || 0),
            saleTargetDtls
          }
          
          this.confirmLoading = true
          this.$api.configure.saveSaleTarget(params).then(res => {
            if (res.success) {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              this.onCancel()
              this.$emit('saveSuccess')
            } 
          }).finally(() => {
            this.confirmLoading = false
          })
        } 
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.input-box
  width 100%
.form-content
  max-height 70vh
  overflow-y auto
  overflow-x hidden
.section-title
  font-size 14px
  color #606266
  margin 10px 0 15px 0
  padding-left 10px

.amount-wrapper
  display flex
  align-items center
  .amount-select
    width 100px
    margin-right 10px
  .amount-input
    flex 1
</style>
